import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  isCabin?: boolean;
};
export const AccommodationRoomArrangement = ({ className, isCabin = false }: Props) => {
  const message = isCabin
    ? t('booking.accommodation.cabinArrangementYourChoiceMessage')
    : t('booking.accommodation.roomArrangementYourChoiceMessage');

  if (!message) {
    return null;
  }

  return (
    <div
      className={classnames(
        'flex items-center gap-10 rounded-12 border-1 border-orange px-10 py-5 font-sans text-12 text-orange',
        className,
      )}
    >
      <Icon name={ICONS.LIGHTBULB} width="2em" />
      {message}
    </div>
  );
};
